import React, { useState, useEffect, useCallback } from 'react';
import { getAllUsers } from '../../firebase/firestoreService';
import { exportAllEmployeesDataToCSV, downloadCSV } from '../../firebase/exportService';
import { EmployeesListModal } from './EmployeesListModal';
import './AdminFirebaseActions.css';

export function AdminFirebaseActions() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [showEmployees, setShowEmployees] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const loadEmployees = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getAllUsers();
      setEmployees(result.success ? result.users : []);
    } catch {
      setEmployees([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadEmployees();
  }, [loadEmployees]);

  const handleExportCSV = async () => {
    try {
      setIsExporting(true);
      setSuccessMessage('');

      const result = await exportAllEmployeesDataToCSV();

      if (result.success) {
        if (result.data.length === 0) {
          window.alert('Aucune donnée trouvée pour les employés');
          return;
        }

        const filename = `activites_employes_${new Date().toISOString().split('T')[0]}.csv`;
        downloadCSV(result.data, filename);

        setSuccessMessage('Export CSV réussi');
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        window.alert(`Erreur lors de l'export : ${result.error}`);
      }
    } catch {
      window.alert('Erreur lors de l\'export des données');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <div className="sidebar-admin-actions">
        {successMessage && (
          <div className="sidebar-admin-success">{successMessage}</div>
        )}

        <button
          type="button"
          className="btn-apply sidebar-admin-btn"
          onClick={handleExportCSV}
          disabled={isExporting}
        >
          {isExporting ? 'Exportation…' : 'Exporter CSV'}
        </button>

        <button
          type="button"
          className="btn-apply sidebar-admin-btn sidebar-admin-btn--secondary"
          onClick={() => {
            loadEmployees();
            setShowEmployees(true);
          }}
        >
          Liste des employés
        </button>
      </div>

      <EmployeesListModal
        open={showEmployees}
        onClose={() => setShowEmployees(false)}
        employees={employees}
        loading={loading}
        onRefresh={loadEmployees}
      />
    </>
  );
}
